import { DxButtonModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectionOptionsPopUpButtonComponent } from './selection-options-pop-up-button.component';



@NgModule({
  declarations: [
    SelectionOptionsPopUpButtonComponent
  ],
	exports: [
		SelectionOptionsPopUpButtonComponent,
	],
  imports: [
    CommonModule,

		DxButtonModule,
  ]
})
export class SelectionOptionsPopUpButtonModule { }
